export default __webpack_public_path__ + "static/media/teamwork-upper.8f5a6377.png";